import { useCallback } from 'react';

import { wallsApi } from '@walls/services/wallsApi';
import {
  useWallAiJobStore,
  useWallContentStore,
  useWallStore,
  type WallBoard,
} from '@walls/store';
import { getThemeGroupingEligibleCards, maxThemeGroupingCards } from '../themeGrouping';

export function useGroupCardsByTheme(board: WallBoard) {
  const topicKey = useWallStore((state) => state.topicKey);
  const setThemeGroupingJob = useWallAiJobStore((state) => state.setThemeGroupingJob);

  return useCallback(async () => {
    if (!board.isOwner || !board.allowAiTools || board.canUseAiGrouping !== true) {
      return;
    }

    const requestedCards = getThemeGroupingEligibleCards(useWallContentStore.getState().cards).slice(
      0,
      maxThemeGroupingCards
    );

    if (requestedCards.length < 2) {
      throw new Error('At least two ungrouped text cards are required.');
    }

    const viewport = document.getElementById('topic-cards');

    if (!viewport || viewport.clientHeight <= 0 || viewport.clientWidth <= 0) {
      throw new Error('The wall is not ready for theme grouping.');
    }

    const job = await wallsApi.groupCardsByTheme(
      board.id,
      requestedCards.map((card) => card.id),
      {
        height: viewport.clientHeight,
        width: viewport.clientWidth,
      },
      topicKey
    );
    setThemeGroupingJob(job);
  }, [
    board.allowAiTools,
    board.canUseAiGrouping,
    board.id,
    board.isOwner,
    setThemeGroupingJob,
    topicKey,
  ]);
}
